export const SHOW_ERROR = 'SHOW_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const CLEAR_SUCCESS = 'CLEAR_SUCCESS';

export function showError(message) {
  return {
    type: SHOW_ERROR,
    payload: message
  }
}

export function clearError() {
  return {
    type: CLEAR_ERROR
  }
}


export function showSuccess(message) {
  return {
    type: SHOW_SUCCESS,
    payload: message
  }
}

export function clearSuccess() {
  return {
    type: CLEAR_SUCCESS
  }
}



// WEBPACK FOOTER //
// ./src/components/snackbars/snackbars-actions.js